import { gql } from "@apollo/client";


export const SEARCH_QUERY = gql`
	query search($search: SearchRequest!) {
		search(search: $search) {
			items
			total
			took
			cursor
		}
	}
`;

export const UPDATE_MANDATORY_INFO = gql`
	mutation updateMandatoryInfo($user_id: ID!, $req: RequestUpdateMandatoryInfo) {
		updateMandatoryInfo(user_id: $user_id, req: $req) {
			status
		}
	}
`;


export const FETCH_AGGREGATE_DATA = gql`
	query ($aggs: AggregationRequest!) {
		aggregate(aggregations: $aggs) {
			aggregations
			took
		}
	}
`;